import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "../components/Box/Box";
import { issueAtom } from "./Summary";
import { FormModel } from "../types/FormTypes";
import { formDataAtom } from "../App";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function ThankYou() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const [issue] = useAtom(issueAtom);

    const location = useLocation();
    const emailContact = location.state?.emailContact;

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("../fler-resor");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
            >
                {({ values }) => (
                    <Form>
                        <Box fullwidth>
                            <h2 ref={h2Ref} tabIndex={-1}>
                                Tack för din ansökan!
                            </h2>
                            <div role="group">
                                <p>
                                    Vi har tagit emot din ansökan.
                                    Du kommer att få en bekräftelse till mejl: <span className="sans-bold">{emailContact}</span>
                                </p>
                                <p>
                                    Ditt ärendenummer är{" "}
                                    <strong>{issue?.id ?? ""}</strong>. Uppge det om du kontaktar
                                    vår kundservice om det här ärendet.
                                </p>

                                <h3>Vad händer nu?</h3>
                                <p>
                                    Din ansökan hanteras av en handläggare.
                                    Om den blir godkänd betalas ersättningen ut på det sätt du valt,
                                    oftast inom två till tre veckor.
                                </p>
                                <p>Om din ansökan nekas får du ett mejl som beskriver anledningen.</p>
                            </div>
                        </Box>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
